import {warning} from "./Warning";
import {Checkbox} from "./FormStyle";
import * as React from 'react'


export const CheckboxInput = (props) => {
    let {value, setValue, label, showWarning, warningLabel} = props;
    return (
        <Checkbox className="checkbox">
            <label>
                <input type="checkbox" value={value} checked={value} onChange={(event) => setValue(event.target.checked)}/>
                <span className="customCheck"/>
                {label}
                {warning(showWarning, warningLabel)}
            </label>
        </Checkbox>
    )
};

export const CheckboxProps = (value, setValue, showWarning, label, warningLabel = '') => ({
    value, setValue, label, showWarning, warningLabel
});